<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col sm="12">
                <b-card v-if="!isSrfRetrieved">
                    <div slot="header">
                        <strong>{{title}} </strong>
                    </div>
                    <b-row>
                        <b-col sm="12">
                            <b-form-group name="srf" label="SRF No" label-for="elementsPrependAppend" description="">
                                <b-input-group>
                                    <srfLookup style="min-width:300px" v-bind:url="apiSrfLookup" v-on:selected="setSrfId($event)" :basic="1" ref="srfLookupInput" :lookupId="srr.srf_num"/>&nbsp;&nbsp;&nbsp;
                                    <b-button variant="primary" @click="retrieveSRF" :disabled="srr.srf_num == ''">Retrieve SRF</b-button>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
                <b-card v-if="isSrfRetrieved">
                        <div slot="header">
                            <strong>{{title}} - {{srr.srf.returning_type}}</strong>
                        </div>
                        <b-row>
                            <b-col>
                                <b-row>
                                    <b-col sm="12">
                                        <b-form-group>
                                            <label>SRR Date</label>
                                                <b-form-input type="date" id="srr_date" v-model="srr.srr_date"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                                <b-row>
                                    <b-col sm="12">
                                        <label for="remarks">Remarks</label>
                                            <textarea class="form-control" rows="5" id="remarks" v-model="srr.remarks"></textarea>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col v-if="srr.srf.srrs.length > 0" sm="6">
                                <br/>
                                <b-card>
                                    <div class ="table-responsive">
                                        <table>
                                            <thead>
                                                <th style="min-width:138px;height:40px">SRR No</th>
                                                <th style="min-width:100px">Date</th>
                                                <th>Generated By</th>
                                            </thead>
                                            <tbody>
                                                <tr v-for="row, index in srr.srf.srrs" :ref="'title'" style="height:40px">
                                                    <td>
                                                        <b-button type="submit" size="md" variant="primary" @click="printSRR(row)">{{row.srr_num}} </b-button>
                                                    </td>
                                                    <td>{{row.srr_date}}</td>
                                                    <td>{{row.author_user_shortname}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-card>
                                </b-col>
                        </b-row>
                        <br/>
                        <hr>
                        <br/>
                        <b-row>
                            <b-col sm="4">
                                <b-form-group>
                                    <label for="srf_num">SRF No</label>
                                        <b-form-input type="text" v-model="srr.srf_num" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="srf_date">SRF Date</label>
                                        <b-form-input type="date" v-model="srr.srf.srf_date" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="status">Status</label>
                                        <b-form-input type="text" v-model="srr.srf.status" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="location_from">Location</label>
                                            <b-form-input type="text" v-model="srr.srf.location_full" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="location_from">Requestor</label>
                                            <b-form-input type="text" v-model="srr.srf.requestor_user_shortname" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="reason">Reason</label>
                                            <b-form-input type="text" v-model="srr.srf.reason" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="location">Event Start Date</label>
                                            <b-form-input type="date" v-model="srr.srf.event_start_date" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="location">Event End Date</label>
                                            <b-form-input type="date" v-model="srr.srf.event_start_date" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col sm="4">
                                    <b-form-group>
                                        <label for="location">Est Return Date</label>
                                            <b-form-input type="date" v-model="srr.srf.return_date" disabled></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col sm="12">
                                    <label for="remarks">SRF Remarks</label>
                                        <textarea class="form-control" rows="5" id="remarks" v-model="srr.srf.remarks" disabled></textarea>
                                </b-col>
                            </b-row>
                    </b-card>
            </b-col>
        </b-row>
        <b-row v-if="isSrfRetrieved">
            <b-col sm="12">
                <b-card>
                    <div slot ="header">
                        <strong>SRR Items</strong>
                    </div>
                    <div class="table-responsive">
                        <table class='table table-striped table-bordered'>
                            <thead>
                                <th width="10px">S/N</th>
                                <th >Product Code</th>
                                <th style="min-width:280px">Product Name</th>
                                <th width="80px">SRF Qty</th>
                                <th width="130px">Unit GMP ({{srr.srf.currency_id}})</th>
                                <th width="130px">Total GMP ({{srr.srf.currency_id}})</th>
                                <th width="110px">SRR Qty</th>
                                <th>Returned GMP ({{srr.srf.currency_id}})</th>
                                <th>Utilized Qty</th>
                                <th>Utilized GMP ({{srr.srf.currency_id}})</th>
                            </thead>
                            <tbody>
                                <tr v-for="row, index in srr.srf.srf_items" >
                                    <td>{{(index*1) + 1}}</td>
                                    <td>{{row.product_id}}</td>
                                    <td>{{row.product_name}}</td>
                                    <td>{{row.qty*1}}</td>
                                    <td>{{row.unit_gmp}}</td>
                                    <td>{{(1 * row.qty * 1 * row.unit_gmp).toFixed(2)}}</td>
                                    <td><input type="number" name="returned_qty" class="form-control" v-model="row.qty_received_current" @change="validateQty(index)" :disabled ="(row.qty*1)- row.qty_returned <= 0 || srr.srf.returning_type != 'RETURNABLE'"></td>
                                    <td>{{(row.unit_gmp*1* row.qty_received_current*1).toFixed(2)}}</td>
                                    <td>{{((row.qty * 1) - ((row.qty_returned * 1) + (row.qty_received_current * 1)))}}</td>
                                    <td>{{((row.unit_gmp*1) *((row.qty * 1) - ((row.qty_returned * 1) + (row.qty_received_current * 1)))).toFixed(2) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="isSrfRetrieved" style="padding:0px 0px 20px 18px">
            <b-button type="submit" size="lg" variant="primary" @click="confirmSave" v-if="(srr.srf.status == 'OPEN' || srr.srf.status == 'PARTIAL') && srr.srf.returning_type == 'RETURNABLE'">Save SRR</b-button>&nbsp;&nbsp;&nbsp;
            <b-button type="button" size="lg" variant="danger" @click="confirmCancel" v-if="(srr.srf.status == 'OPEN' || srr.srf.status == 'PARTIAL') && srr.srf.returning_type == 'RETURNABLE'" >Cancel</b-button>&nbsp;&nbsp;&nbsp;
            <b-button type="button" size="lg" variant="success" @click="print" v-if="srr.srf.status != 'OPEN' || srr.srf.returning_type != 'RETURNABLE'">Print</b-button>&nbsp;&nbsp;&nbsp;
            <b-button type="button" size="lg" variant="danger" @click="back" v-if="srr.srf.status != 'OPEN' || srr.srf.returning_type != 'RETURNABLE'">Back</b-button>
        </b-row>
        <div>
                <b-modal v-model="modalShow" @ok="save" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                        <p style="color:darkblue">Confirmed Save SRR?</p>
                    </b-modal>
                    <b-modal v-model="modalCancelShow" @ok="cancel" title="Confirmation"  centered header-bg-variant="success" no-close-on-backdrop>
                            <p style="color:darkblue">Confirmed Cancel?</p>
                    </b-modal>
                    <b-modal ref="myModalRef" hide-header-close hide-footer title="Stock Requisiton Return" centered header-bg-variant="success" no-close-on-backdrop no-close-on-esc>
                        <div class="d-block text-center">
                            <p>Stock Requisition Return <strong style="color:green"> {{srrDocNo}}</strong> is saved.<br/><br/></p>
                        </div>
                            <b-btn class="float-right" variant="outline-danger" @click="hideModal">Ok</b-btn>
                    </b-modal>
                    <b-modal ref="myErrorModalRef" hide-header-close hide-footer title="Invalid Entries" centered header-bg-variant="danger" no-close-on-backdrop no-close-on-esc>
                        <div class="d-block text-center">
                            <p style="color:red">{{errorMessage}}</p>
                        </div>
                            <b-btn class="float-right" variant="danger" @click="hideErrorModal">OK</b-btn>
                </b-modal>
        </div>
    </div>
    </template>
<script>
import axios from 'axios'
import srfLookup from '@/components/Autocomplete.vue'
import {authHeader, apiSrfLookup, apiSrrSave,apiCountryLookup} from '@/functions/common.vue'
import productLookup from '@/components/Autocomplete.vue'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
pdfMake.vfs = pdfFonts.pdfMake.vfs;
pdfMake.fonts = {
    "ukai": {
        normal: 'ukai.ttf',
        bold: 'ukai.ttf',
        italics: 'ukai.ttf',
        bolditalics: 'ukai.ttf'
    },
    "Garuda": {
        normal: 'Garuda.ttf',
        bold: 'Garuda.ttf',
        italics: 'Garuda.ttf',
        bolditalics: 'Garuda.ttf'
    },
    "Hanumanb": {
        normal: 'Hanumanb.ttf',
        bold: 'Hanumanb.ttf',
        italics: 'Hanumanb.ttf',
        bolditalics: 'Hanumanb.ttf'
    },
};
export default
{
    name: 'srr',
    components: {srfLookup},
    data: () => {
        return {
            modalShow:false,
            modalCancelShow:false,
            country_name:'',
            srfNum: '',
            modalMsg: '',
            font:'ukai',
            isSrfRetrieved: false,
            title:'New SRR',
            errorMessage:'',
            apiSrfLookup : apiSrfLookup,
            srrDocNo :'test',
            isValid : true,
            received_qty:0,
            srr:
            {
                srr_num: '',
                srr_date: '',
                srf_num:'',
                remarks:'',
                reference_num:'',
                srr_items:{},
                srf: {
                    srrs:[]
                }
            },
        }
    },
    created()
    {
        if (localStorage.getItem("srr_new.srf_num") != "")
        {
            this.isSrfRetrieved = true
            var srfNum = localStorage.getItem("srr_new.srf_num")
            var url = this.apiSrfLookup

            axios.get(url, {params: {q: srfNum, get:1}},authHeader())
            .then(response =>
            {
                this.list = response.data.data.list

                if (this.list.length > 0)
                {
                    this.item = this.list[0]
                    if (this.item !== null)
                    {
                        this.isSrfRetrieved = true
                        var srf = this.item
                        if(srf.country_id != null)
                        {
                            axios.get(apiCountryLookup, {params: {q: srf.country_id}})
                                .then(response =>
                                {

                                    if (response.data != null)
                                    {
                                        this.list = response.data.data.list
                                        this.item = this.list[0]
                                        this.country_name = this.item.country_name
                                        this.country_name = this.country_name.toUpperCase()
                                    }
                                })
                        }
                        this.srr.srf = srf
                        this.srr.srf_num = srf.srf_num

                        this.srr.srf.srrs = this.item.srrs
                        for(let n=0; n<this.srr.srf.srrs.length; n++)
                        {
                            var date = this.srr.srf.srrs[n].srr_date
                            date = new Date(date);
                            var result = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/'+  ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                            this.srr.srf.srrs[n].srr_date = result
                        }
                        let curDate = new Date()
                        curDate = curDate.toISOString().substr(0,10)
                        this.srr.srr_date = curDate
                    }
                }
            })
            .catch(error => alert(error))
        }
        else
        {
            this.isSrfRetrieved = false
            this.srfNum = ''
        }
    },
    methods:
    {
        printSRR(row)
        {
            console.log(row)
            var srr_num = row.srr_num
                var r = []
                var srrItems = []
                r = [
                    {
                        text: 'S/No',
                        style: 'itemsHeader'
                    },
                    {
                        text: 'Product Code',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Description',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Qty',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    },
                ]
                srrItems.push(r)

                var items =row.srr_items
                for (let key in items) {
                    var data = items[key]
                    var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    if (data.product_name == null)
                    {
                        data.product_name = ""
                    }
                    r = [
                        {
                            text: (key * 1) + 1,
                            style: 'itemText'
                        },
                        {
                            text: data.product_id,
                            style: 'itemText'
                        },
                        {
                            text: data.product_name,
                            style: 'itemText'
                        },
                        {
                            text: qty,
                            style: 'itemNumber'
                        },
                    ]
                    srrItems.push(r)
                }

                var ddHeader = {
                    columns: [
                        [{
                                text: 'ELKEN '+ this.country_name +' STOCK REQUSITION RETURN',
                                style: 'invoiceTitle',
                                width: '*'
                            },
                            {
                                stack: [
                                    {
                                        columns: [
                                            {
                                                text: 'SRR #',
                                                style: 'invoiceSubTitle',
                                                width: 95

                                            },
                                            {
                                                text: srr_num,
                                                style: 'invoiceSubValue',
                                                width: 100
                                            },

                                        ]
                                    },
                                    {
                                        text:' '
                                    },
                                    {
                                        columns: [

                                            {
                                                text: 'SRR Date',
                                                style: 'invoiceSubTitle',
                                                width: 95

                                            },
                                            {
                                                text: row.srr_date,
                                                style: 'invoiceSubValue',
                                                width: 100
                                            },

                                        ]

                                    },
                                    {
                                        text:' ',
                                    },
                                    {
                                        columns: [
                                            {
                                                text: 'Reference SRF#',
                                                style: 'invoiceSubTitle',
                                                width: 95

                                            },
                                            {
                                                text: row.srf_num,
                                                style: 'invoiceSubValue',
                                            },

                                        ]

                                    },
                                    {
                                        text:' ',
                                    },
                                    {
                                        columns: [
                                            {
                                                text: 'Reason',
                                                style: 'invoiceSubTitle',
                                                width: 95

                                            },
                                            {
                                                text: '',
                                                style: 'invoiceSubValue',
                                                width: 100
                                            },

                                        ]
                                    },
                                ]
                            }
                        ],
                    ],
                }

                var dd = {
                    header: function (pageNumber, pageCount) {
                        return {
                            margin: [0, 10, 0, 0],
                            columns: [{
                                    text: '',
                                    style: 'documentHeaderLeft'
                                },
                                {
                                    text: srr_num,
                                    style: 'documentHeaderCenter'
                                },
                                {
                                    text: '',
                                    style: 'documentHeaderRight'
                                }
                            ]
                        }
                    },
                    footer: function (pageNumber, pageCount) {
                        return {
                            margin: [0, 0, 0, 50],
                            columns: [{
                                    text: '',
                                    style: 'documentFooterLeft'
                                },
                                {
                                    text: 'Page ' + pageNumber + " of " + pageCount,
                                    style: 'documentFooterCenter'
                                },
                                {
                                    text: '',
                                    style: 'documentFooterRight'
                                }
                            ]
                        };
                    },
                    content: [
                        ddHeader,
                        // Line breaks
                        '\n\n',
                        {
                            layout: 'lightHorizontalLines',
                            table: {

                                headerRows: 1,
                                widths: [25, 68, '*', 45, 45],
                                body: srrItems

                            }, // table
                        },
                        {
                            text: 'Remarks',
                            style: 'notesTitle'
                        },
                        {
                            text: row.remarks,
                            style: 'notesText'
                        },
                        {
                            columns: [
                                    {
                                        stack: [
                                            {
                                                text: 'Issued By',
                                                style:'signaturePlaceholder'
                                            },

                                            {
                                                text: '______________________________',
                                                style:'signaturePlaceholder'
                                            },
                                            {
                                                text: 'Name  : '+ row.author_user_shortname,
                                                style:'signatureName'

                                            },
                                            {
                                                text: 'Date  : ' + row.srr_date,
                                                style:'signatureJobTitle'

                                            }
                                            ],
                                            width: 160
                                    },
                                    {
                                        stack: [
                                            {
                                                text: '  ',
                                                style:'signaturePlaceholder'
                                            },

                                            {
                                                text: '                      ',
                                                style:'signaturePlaceholder'
                                            },
                                            {
                                                text: '  ',
                                                style:'signatureName'

                                            },
                                            {
                                                text: '      ',
                                                style:'signatureJobTitle'

                                            }
                                            ],
                                            width: 180
                                    },
                                    {
                                        stack: [
                                            {
                                                text: 'Received By',
                                                style:'signaturePlaceholder'
                                            },

                                            {
                                                text: '______________________________',
                                                style:'signaturePlaceholder'
                                            },
                                            {
                                                text: 'Name  :',
                                                style:'signatureName'

                                            },
                                            {
                                                text: 'Date  :',
                                                style:'signatureJobTitle'

                                            }
                                            ],
                                            width: 160
                                    }

                                ]
                    },
                    ],
                    styles: {
                        // Document Header
                        documentHeaderLeft: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'left'
                        },
                        documentHeaderCenter: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'center'
                        },
                        documentHeaderRight: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'right'
                        },
                        // Document Footer
                        documentFooterLeft: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'left'
                        },
                        documentFooterCenter: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'center'
                        },
                        documentFooterRight: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'right'
                        },
                        // Invoice Title
                        invoiceTitle: {
                            fontSize: 22,
                            bold: true,
                            alignment: 'left',
                            margin: [0, 0, 0, 15]
                        },
                        // Invoice Details
                        invoiceSubTitle: {
                            fontSize: 10,
                            alignment: 'left'
                        },
                        invoiceSubValue: {
                            fontSize: 10,
                            alignment: 'left'
                        },
                        // Billing Headers
                        invoiceBillingTitle: {
                            fontSize: 14,
                            bold: true,
                            alignment: 'left',
                            margin: [0, 20, 0, 5],
                        },
                        // Billing Details
                        invoiceBillingDetails: {
                            alignment: 'left'

                        },
                        invoiceBillingAddressTitle: {
                            margin: [0, 7, 0, 3],
                            bold: true
                        },
                        invoiceBillingAddress: {

                        },
                        // Items Header
                        itemsHeader: {

                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            bold: true
                        },
                        // Item Title
                        itemTitle: {
                            bold: true,
                        },
                        itemSubTitle: {
                            //italics: true,
                            fontSize: 10
                        },
                        itemText: {
                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            alignment: 'left',
                        },
                        itemNumber: {
                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            alignment: 'right',
                        },
                        itemTotal: {
                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'right',
                        },

                        // Items Footer (Subtotal, Total, Tax, etc)
                        itemsFooterSubTitle: {
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'right',
                        },
                        itemsFooterSubValue: {
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'center',
                        },
                        itemsFooterTotalTitle: {
                            fontSize: 11,
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'right',
                        },
                        itemsFooterTotalValue: {
                            fontSize: 11,
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'center',
                        },
                        signaturePlaceholder: {
                            fontSize: 10,
                            margin: [0, 70, 0, 0],
                        },
                        signatureName: {
                            fontSize: 10,
                            margin: [0, 10, 0, 0],
                            bold: true,
                            alignment: 'left',
                        },
                        signatureJobTitle: {
                            fontSize: 10,
                            margin: [0, 20, 0, 0],
                            bold: true,
                            alignment: 'left',
                        },
                        notesTitle: {
                            fontSize: 10,
                            bold: true,
                            margin: [0, 30, 0, 3],
                        },
                        notesText: {
                            fontSize: 10
                        },
                        center: {
                            alignment: 'center',
                        },
                    },
                    defaultStyle: {
                        columnGap: 20,
                        font:this.font
                    }
                }
                pdfMake.createPdf(dd).open();
    },
        print()
        {
                var srfNum = this.srr.srf_num
                var row = []
                var date = new Date(this.srr.srf.srf_date)
                var srfDate = "" + (date.getDate() > 9 ? '' : '0') + date.getDate() + '/' + ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1) + '/' + date.getFullYear()
                var srrItems = []
                var returnDate = '-'
                var eventStart = '-'
                var eventEnd = '-'
                if(this.srr.srf.event_start_date != null)
                {
                    var s = new Date(this.srr.srf.event_start_date)
                    eventStart = "" + (s.getDate() > 9 ? '' : '0') + s.getDate() + '/' + ((s.getMonth() + 1) > 9 ? '' : '0') + (s.getMonth() + 1) + '/' + s.getFullYear()
                }
                if(this.srr.srf.event_start_date != null)
                {
                    var e = new Date(this.srr.srf.event_end_date)
                    eventEnd = "" + (e.getDate() > 9 ? '' : '0') + e.getDate() + '/' + ((e.getMonth() + 1) > 9 ? '' : '0') + (e.getMonth() + 1) + '/' + e.getFullYear()
                }
                if(this.srr.srf.return_date != null)
                {
                    var d = new Date(this.srr.srf.return_date)
                    returnDate = "" + (d.getDate() > 9 ? '' : '0') + d.getDate() + '/' + ((d.getMonth() + 1) > 9 ? '' : '0') + (d.getMonth() + 1) + '/' + d.getFullYear()
                }
                row = [
                    {
                        text: 'S/No',
                        style: 'itemsHeader'
                    },
                    {
                        text: 'SKU',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Description',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'SRF Qty',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Unit GMP',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Total GMP',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text:'SRR Qty',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    },
                    {
                        text: 'Returned GMP',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text:'Utilized Qty',
                        style: ['itemsHeader'],
                        alignment: 'right'
                    },
                    {
                        text:'Utilized GMP',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                ]
                srrItems.push(row)
                var items = this.srr.srf.srf_items
                for (let key in items)
                {
                    var data = items[key]
                    var qty = (data.qty* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    var qty_returned = (data.qty_returned* 1).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    var total_gmp = (data.amount_total* 1).toFixed(2)
                    total_gmp = total_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    var unit_gmp =(data.unit_gmp* 1).toFixed(2)
                    unit_gmp = unit_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    var returned_gmp = (data.unit_gmp*1* data.qty_received_current*1).toFixed(2)
                    returned_gmp = returned_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    var utilized_qty = ((data.qty * 1) - ((data.qty_returned * 1) + (data.qty_received_current * 1)))
                    utilized_qty = utilized_qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    var utilized_gmp = ((data.unit_gmp*1) *((data.qty * 1) - ((data.qty_returned * 1) + (data.qty_received_current * 1)))).toFixed(2)
                    utilized_gmp = utilized_gmp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    if (data.product_name == null)
                    {
                        data.product_name = ""
                    }
                    row = [
                        {
                            text: (key * 1) + 1,
                            style: 'itemText'
                        },
                        {
                            text: data.product_id,
                            style: 'itemText'
                        },
                        {
                            text: data.product_name,
                            style: 'itemText'
                        },
                        {
                            text: qty,
                            style: 'itemNumber'
                        },
                        {
                            text: unit_gmp,
                            style: 'itemText'
                        },
                        {
                            text: total_gmp,
                            style: 'itemText'
                        },
                        {
                            text: qty_returned,
                            style: 'itemNumber'
                        },
                        {
                            text: returned_gmp,
                            style: 'itemText'
                        },
                        {
                            text: utilized_qty,
                            style: 'itemText'
                        },
                        {
                            text: utilized_gmp,
                            style: 'itemText'
                        },
                    ]
                    srrItems.push(row)
                }
                var srrsItems = []
                var srrRow = []
                srrRow = [
                    {
                        text: 'S/No',
                        style: 'itemsHeader'
                    },
                    {
                        text: 'SRR #',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'SRR Date',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },
                    {
                        text: 'Generated By',
                        style: ['itemsHeader'],
                        alignment: 'left'
                    },

                ]
                srrsItems.push(srrRow)
                var srrs = this.srr.srf.srrs
                for (let key in srrs) {
                    var gd = srrs[key]
                    srrRow = [
                        {
                            text: (key * 1) + 1,
                            style: 'itemText'
                        },
                        {
                            text: gd.srr_num,
                            style: 'itemText'
                        },
                        {
                            text: gd.srr_date,
                            style: 'itemText'
                        },
                        {
                            text: gd.author_user_shortname,
                            style: 'itemText'
                        },

                    ]
                    srrsItems.push(srrRow)
                }

                var ddHeader = {
                    columns: [
                        [{
                                text: 'ELKEN '+this.country_name +' STOCK REQUSITION RETURN',
                                style: 'invoiceTitle',
                                width: '*'
                            },
                            {
                                stack: [{
                                        columns: [
                                            {
                                                text: 'SRF #',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: srfNum,
                                                style: 'invoiceSubValue',
                                                width: 130
                                            },
                                            {text: '',style:'invoiceSubValue',width: 80},
                                            {
                                                text: 'SRF Date',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: srfDate,
                                                style: 'invoiceSubValue',
                                                width: 130

                                            },
                                        ]
                                    },
                                    {
                                        columns: [
                                            {
                                                text: 'Stock Location',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: this.srr.srf.location_full,
                                                style: 'invoiceSubValue',
                                                width: 130
                                            },
                                            {text: '',style:'invoiceSubValue',width: 80},
                                            {
                                                text: 'Status',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: this.srr.srf.status,
                                                style: 'invoiceSubValue',
                                                width: 130
                                            },
                                        ]

                                    },
                                    {
                                        columns: [

                                            {
                                                text: 'Requestor',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: this.srr.srf.requestor_user_shortname,
                                                style: 'invoiceSubValue',
                                                width: 130
                                            },
                                            {text: '',style:'invoiceSubValue',width: 80},
                                            {
                                                text: 'Reason',
                                                style: 'invoiceSubTitle',
                                                width: 90
                                            },
                                            {
                                                text: this.srr.srf.reason,
                                                style: 'invoiceSubValue',
                                                width: 130
                                            },
                                        ]

                                    },
                                    {
                                        columns: [
                                            {
                                                text: 'Event Start Date',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: eventStart,
                                                style: 'invoiceSubValue',
                                                width: 130
                                            },
                                            {text: '',style:'invoiceSubValue',width: 80},
                                            {
                                                text: 'Event End Date',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: eventEnd,
                                                style: 'invoiceSubValue',
                                                width: 130

                                            },
                                        ]

                                    },
                                    {
                                        columns: [
                                            {
                                                text: 'Returnning Type',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: this.srr.srf.returning_type,
                                                style: 'invoiceSubValue',
                                                width: 130
                                            },
                                            {text: '',style:'invoiceSubValue',width: 80},
                                            {
                                                text: 'Est Return Date',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: returnDate,
                                                style: 'invoiceSubValue',
                                                width: 130
                                            },
                                        ]

                                    },
                                    {
                                        columns: [
                                            {
                                                text: 'Currency Code',
                                                style: 'invoiceSubTitle',
                                                width: 90

                                            },
                                            {
                                                text: this.srr.srf.currency_id,
                                                style: 'invoiceSubValue',
                                                width: 130

                                            },
                                        ]

                                    },
                                ]
                            }
                        ],
                    ],
                }

                var dd = {
                    header: function (pageNumber, pageCount) {
                        return {
                            margin: [0, 10, 0, 0],
                            columns: [{
                                    text: '',
                                    style: 'documentHeaderLeft'
                                },
                                {
                                    text: srfNum,
                                    style: 'documentHeaderCenter'
                                },
                                {
                                    text: '',
                                    style: 'documentHeaderRight'
                                }
                            ]
                        }
                    },
                    footer: function (pageNumber, pageCount) {
                        return {
                            margin: [0, 0, 0, 50],
                            columns: [{
                                    text: '',
                                    style: 'documentFooterLeft'
                                },
                                {
                                    text: 'Page ' + pageNumber + " of " + pageCount,
                                    style: 'documentFooterCenter'
                                },
                                {
                                    text: '',
                                    style: 'documentFooterRight'
                                }
                            ]
                        };
                    },
                    content: [
                        ddHeader,
                        // Line breaks
                        {
                            text: 'SRR Lists',
                            style: 'notesTitle'
                        },
                        {
                        table: {
                            // headers are automatically repeated if the table spans over multiple pages
                            // you can declare how many rows should be treated as headers
                            headerRows: 0,
                            widths: [25,'auto',80,'auto'],
                            body: srrsItems
                        }, // table
                        layout: 'lightHorizontalLines'
                        },
                        '\n\n',
                        {
                            layout: 'lightHorizontalLines',
                            table: {

                                headerRows: 1,
                                widths: ['auto', 'auto', 'auto', 'auto', 'auto','auto','auto','auto','auto','auto'],
                                body: srrItems

                            }, // table
                        },
                        {
                            text: 'SRF Remarks',
                            style: 'notesTitle'
                        },
                        {
                            text: this.srr.srf.remarks,
                            style: 'notesText'
                        },
                    ],
                    styles:
                    {
                        // Document Header
                        documentHeaderLeft: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'left'
                        },
                        documentHeaderCenter: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'center'
                        },
                        documentHeaderRight: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'right'
                        },
                        // Document Footer
                        documentFooterLeft: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'left'
                        },
                        documentFooterCenter: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'center'
                        },
                        documentFooterRight: {
                            fontSize: 10,
                            margin: [5, 5, 5, 5],
                            alignment: 'right'
                        },
                        // Invoice Title
                        invoiceTitle: {
                            fontSize: 22,
                            bold: true,
                            alignment: 'left',
                            margin: [0, 0, 0, 15]
                        },
                        // Invoice Details
                        invoiceSubTitle: {
                            fontSize: 10,
                            alignment: 'left'
                        },
                        invoiceSubValue: {
                            fontSize: 10,
                            alignment: 'left'
                        },
                        // Billing Headers
                        invoiceBillingTitle: {
                            fontSize: 14,
                            bold: true,
                            alignment: 'left',
                            margin: [0, 20, 0, 5],
                        },
                        // Billing Details
                        invoiceBillingDetails: {
                            alignment: 'left'

                        },
                        invoiceBillingAddressTitle: {
                            margin: [0, 7, 0, 3],
                            bold: true
                        },
                        invoiceBillingAddress: {

                        },
                        // Items Header
                        itemsHeader: {

                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            bold: true
                        },
                        // Item Title
                        itemTitle: {
                            bold: true,
                        },
                        itemSubTitle: {
                            //italics: true,
                            fontSize: 10
                        },
                        itemText: {
                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            alignment: 'left',
                        },
                        itemNumber: {
                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            alignment: 'right',
                        },
                        itemTotal: {
                            fontSize: 10,
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'right',
                        },

                        // Items Footer (Subtotal, Total, Tax, etc)
                        itemsFooterSubTitle: {
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'right',
                        },
                        itemsFooterSubValue: {
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'center',
                        },
                        itemsFooterTotalTitle: {
                            fontSize: 11,
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'right',
                        },
                        itemsFooterTotalValue: {
                            fontSize: 11,
                            margin: [0, 5, 0, 5],
                            bold: true,
                            alignment: 'center',
                        },
                        signaturePlaceholder: {
                            fontSize: 10,
                            margin: [0, 70, 0, 0],
                        },
                        signatureName: {
                            fontSize: 10,
                            margin: [0, 10, 0, 0],
                            bold: true,
                            alignment: 'left',
                        },
                        signatureJobTitle: {
                            fontSize: 10,
                            margin: [0, 20, 0, 0],
                            bold: true,
                            alignment: 'left',
                        },
                        notesTitle: {
                            fontSize: 10,
                            bold: true,
                            margin: [0, 30, 0, 3],
                        },
                        notesText: {
                            fontSize: 10
                        },
                        center: {
                            alignment: 'center',
                        },
                    },
                    defaultStyle: {
                        columnGap: 20,
                        font:this.font
                    }
                }
                pdfMake.createPdf(dd).open();
            },
        retrieveSRF()
        {
            if (this.srr.srf_num != '')
            {
                this.isSrfRetrieved = true
            }
        },
        setSrfId(obj)
        {
            if (obj !== null)
            {
                this.srr.srr_date = curDate
                this.srr.srf = obj
                this.srr.srf_num = obj.srf_num
                if(this.obj.country_id != null)
                        {
                            axios.get(apiCountryLookup, {params: {q: this.obj.country_id}})
                                .then(response =>
                                {

                                    if (response.data != null)
                                    {
                                        this.list = response.data.data.list
                                        this.item = this.list[0]
                                        this.country_name = this.item.country_name
                                        this.country_name = this.country_name.toUpperCase()
                                    }
                                })
                        }

                let curDate = new Date()
                curDate = curDate.toISOString().substr(0,10)
                this.srr.srr_date = curDate
            }
            else
            {
                this.srr.srf_num = null
            }
        },
        confirmSave()
        {
            this.modalShow = true
        },
        save()
        {
            axios.post(apiSrrSave, this.srr, authHeader())
                        .then (res => {
                        var r = res.data
                        if (r.code == 1)
                        {
                            this.srrDocNo = r.data.srr_num
                            this.$refs.myModalRef.show()
                        }
                        else
                        {
                            this.errorMessage = r.msg
                            this.$refs.myErrorModalRef.show()
                        }
                        })
            .catch(error => alert(error))

        },
        confirmCancel()
        {
            this.modalCancelShow = true
        },
        cancel()
        {
            this.$router.push({ name: 'Stock Requisition Returns (SRRS)'})
        },
        hideModal ()
        {
            this.$refs.myModalRef.hide()
            this.$router.push({ name: 'Stock Requisition Returns (SRRS)'})
        },
        hideErrorModal()
        {
            this.$refs.myErrorModalRef.hide()
        },
        validateQty(index)
        {
            if(!this.lockEntry && 0)
            {
                var updateQty
                updateQty = this.srr.srf.srf_items[index].qty_received_current *1
                var requestedQty
                requestedQty = this.srr.srf.srf_items[index].qty*1
                var returnedQty = this.srr.srf.srf_items[index].qty_returned*1

                var maxQty = (requestedQty *1) - (returnedQty*1)
                if (updateQty < 0)
                {
                    this.errorMessage = "SRR Quantity Value must not be a negative number"
                    this.$refs.myErrorModalRef.show()
                    this.srr.srf.srf_items[index].qty_received_current = 0
                }
                else if( updateQty > maxQty)
                {
                    this.errorMessage = "SRR Quantity Value must not exceed the requested of the SRF Qty"
                    this.$refs.myErrorModalRef.show()
                    this.srr.srf.srf_items[index].qty_received_current = 0
                }
            }
        },
        back()
        {
            this.$router.push({ name: 'Stock Requisition Returns (SRRS)'})
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/views/srr/srr.vue